import './SipCalculator.css'

import React, { useState, useEffect } from 'react';
import RangeInput from './Component/RangeInput';
import Pie from './Component/Pie';
import NumberCount from './Component/NumberCount';
import Button from '../../Components/Button/Button.js'
import SectionIds from '../../Helper/SectionId.js';
import scrollIntoView from '../../Helper/ScrollIntoView.js';
import SectionWithAnalytics from '../../Components/sectionWithAnalytics.js';

export default function SipCalculator() {

    const [monthlyInvestment, setMonthlyInvestment] = useState(500);
    const [annualReturnRate, setAnnualReturnRate] = useState(1);
    const [timePeriod, setTimePeriod] = useState(1);
    const [error, setError] = useState(false);
    const [random, setRandom] = useState({
        investedAmount: 500,
        estimatedReturns: 500,
        totalAmount: 1000,
    });

    function calculateInvestment() {

        const monthlyRate = annualReturnRate / 12 / 100; // Convert annual rate to monthly rate
        const months = timePeriod * 12; // Convert years to months

        let investedAmount = 0;
        let futureValue = 0;

        for (let i = 0; i < months; i++) {
            investedAmount += monthlyInvestment;
            futureValue += monthlyInvestment;
            futureValue *= 1 + monthlyRate;
        }

        // Round to 2 decimal places
        investedAmount = parseFloat(investedAmount.toFixed(2));
        futureValue = parseFloat(futureValue.toFixed(2));

        const estimatedReturns = futureValue - investedAmount;
        const totalAmount = investedAmount + estimatedReturns;
        return { investedAmount, estimatedReturns, totalAmount };
    }

    useEffect(() => {

        const { investedAmount, estimatedReturns, totalAmount } = calculateInvestment();
        setRandom({
            totalAmount: totalAmount,
            estimatedReturns: estimatedReturns,
            investedAmount: investedAmount,
        });
    }, [monthlyInvestment, annualReturnRate, timePeriod]);

    return (
        <SectionWithAnalytics className='section section-sip container-vertical res-gap-32' id={SectionIds.sectionSipCalculator}>
            <div className='sip-top-section res-gap-32'>
                <div className='sip-inputs container-vertical res-gap-32'>

                    <h3 className='text-align-left'>SIP Calculator</h3>
                    <div className='container-vertical res-gap-16'>
                        <RangeInput label='Monthly Investment Amount'
                            leading='₹'
                            min={500}
                            max={1000000}
                            onError={(e) => {
                                setError(
                                    (prev) => prev || e
                                );
                            }}
                            onChange={
                                (x) => {
                                    setMonthlyInvestment(parseInt(x));
                                }} />
                        <RangeInput label='Expected return rate (p.a)'
                            trailing='%'
                            min={1}
                            max={30}
                            onError={(e) => {
                                setError(
                                    (prev) => prev || e
                                );
                            }}
                            onChange={
                                (x) => {
                                    setAnnualReturnRate(parseInt(x));
                                }} />
                        <RangeInput label='Time Period'
                            trailing='Years'
                            min={1}
                            max={40}
                            onError={(e) => {
                                setError(
                                    (prev) => prev || e
                                );
                            }}
                            onChange={
                                (x) => {
                                    setTimePeriod(parseInt(x));
                                }} />

                    </div>
                </div>
                <div className='sip-pie'>
                    <Pie total={random.totalAmount} highlightedAmount={random.estimatedReturns} />

                    <div className='legend container-horizontal res-gap-16'>
                        <div className='legend-item container-horizontal res-gap-8'>
                            <span style={{
                                width: '50px',
                                height: 'auto',
                                backgroundColor: '#E9E9E9',
                                borderRadius: '4px'
                            }} className='color-container'>
                            </span>
                            <span className='clr-primary-heading fw-medium fs-small'>Invested Amt</span>
                        </div>
                        <div className='legend-item container-horizontal res-gap-8'>
                            <span style={{
                                width: '50px',
                                height: 'auto',
                                background: 'linear-gradient(107deg, #BA62FF 0%, #AA42FC 40%, #7241FF 100%)',
                                borderRadius: '4px'
                            }} className='color-container'>
                            </span>
                            <span className='clr-primary-heading fw-medium fs-small'>Estimated Returns</span>
                        </div>
                    </div>
                </div>
                <div className='sip-outputs container-vertical res-gap-8 ' >
                    <NumberCount
                        label='Invested Amount'
                        count={random.investedAmount}
                        error={error}
                    />
                    <NumberCount
                        label='Estimated Returns'
                        count={random.estimatedReturns}
                        error={error}
                    />
                    <NumberCount
                        label='Total Amount'
                        count={random.totalAmount}
                        error={error}
                    />

                </div>
                <div className='sip-invest-now'>
                    <Button name='Invest Now' onClick={() => scrollIntoView(SectionIds.sectionContactMe )} />
                </div>
            </div>



        </SectionWithAnalytics>
    );
}
